import axios from 'axios'
import store from '~/store'
import router from '~/router'
import i18n from './vue-i18n'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// if(process.env.MIX_A_MODE == 'prod'){
//   axios.defaults.baseURL ="./public"
// }

axios.interceptors.request.use(request => {
    if (store.getters.authToken) {
        request.headers.common['Authorization'] = `Bearer ${store.getters.authToken}`
    }
    return request
})

axios.interceptors.response.use(response => response, error => {
    const { status, data } = error.response

    if (status >= 500) {
      console.log(error)
        // store.dispatch('responseMessage', {
        //     type: 'error',
        //     text: i18n.t('error_alert_text'),
        //     title: i18n.t('error_alert_title'),
        //     modal: true
        // })
    }

    if (status === 422 && store.getters.authCheck) {

      let c = " "
      if(data.errors.phone){
        c+=data.errors.phone //checking validation error response for phone from server
      }

      if(data.errors.email){
        c+=","+data.errors.email //checking validation error response for email from server
      }
      store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Sorry an error occured.'+c,
              title: 'Error',
              modal: false
          })
        console.log(data.errors)


  }
    if (status === 401 && store.getters.authCheck) {
        store.dispatch('responseMessage', {
                type: 'warning',
                text: i18n.t('token_expired_alert_text'),
                title: i18n.t('token_expired_alert_title'),
                modal: true
            })
            .then(async() => {
                await store.dispatch('logout')

                router.push({ name: 'welcome' })
            })
    }

    return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js